import React from "react";
import { Legend } from "recharts";

const ChartLegend = ({
  data,
  colorArray,
  iconSize = 0,
  verticalAlign = "top",
  align = "left",
  style = { position: "relative" }
}) => {
  return (
    <>
      <Legend
        wrapperStyle={{ position: "relative" }}
        payload={data.map((item, index) => ({
          id: item.name,
          value: `${item.name}: ${item.value}`,
          color: colorArray[index % colorArray.length]
        }))}
        iconSize={iconSize}
        verticalAlign={verticalAlign}
        align={align}
        style={style}
      />
    </>
  );
};
export default ChartLegend;
